import { Outlet } from 'react-router-dom';

import { ProtectedRoute } from '@/components/auth';
import { SidebarProvider } from '@/contexts/sidebar-context';

import { TenantLayoutWrapper } from './tenant-layout-wrapper';

export function TenantLayout() {
  return (
    <ProtectedRoute requiredRoles={['tenant-owner']}>
      <SidebarProvider initialCollapsed={false}>
        <TenantLayoutWrapper>
          <Outlet />
        </TenantLayoutWrapper>
      </SidebarProvider>
    </ProtectedRoute>
  );
}
